// import './css/index.css';
import './App.css';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import registerServiceWorker from './registerServiceWorker';

const backStyle = {
  width: "100%",
  position: "absolute",
  height: "100%"
};

ReactDOM.render(
 <div style={backStyle}>
    <App />
  </div>,
  document.getElementById('savariaApp')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js